export default "__VITE_ASSET__Cg6ToCNU__"